import React, { useState, useEffect } from 'react'
import StaffImg from '../assets/staff-img.png';
import StaffImg1 from '../assets/staff-img1.gif';
import Loading from '../general/Loading';


const DeliveryHistory = ({ userData }) => {
    const [orders, setOrders] = useState([]);
    const [excOrders, setexcOrders] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedOrder, setSelectedOrder] = useState('');
    const [showDetail, setShowDetail] = useState(false);
       const [loading, setLoading] = useState(false);
       const [orderAddress, setOrderAddress] = useState('');    

    // Fetch staff members on component mount
    useEffect(() => {
        const fetchAssignedOrder = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://api.kcmstore.in/store/get-assigned-order');
                if (response.ok) {
                    const data = await response.json();
//   const sortedOrders = data.sort((a, b) => a.id - b.id);
     const sortedOrders = Array.isArray(data)
            ? [...data].sort((a, b) => new Date(b.order_date) - new Date(a.order_date))
            : [];
                    setLoading(false);
                    setOrders(sortedOrders);
                } else {
                    setLoading(false);
                    console.error('Failed to fetch staff members');
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching staff:', error);
            }
        };

        fetchAssignedOrder();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
    };

      const filteredOrders = orders.filter(order =>
        formatDate(order.order_date).toLowerCase().includes(searchQuery.toLowerCase()) ||
        order.delivery_agent_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        order.order_status.toLowerCase().includes(searchQuery.toLowerCase())
      );

    const handleShowDetail = (order) => {
        setSelectedOrder(order);
        console.log(order);
        setShowDetail(true);
    }

    const getOrderLocation = async (lat, lon) => {
      try {
          const response = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json`);
          const data = await response.json();
  
          return data.display_name || 'Unknown location';
      } catch (error) {
          console.error('Error fetching order address:', error);
          return 'Failed to fetch location';
      }
  };
  
    useEffect(() => {
      const fetchOrderAddress = async () => {
          if (selectedOrder?.lat && selectedOrder?.longi) {
              const address = await getOrderLocation(selectedOrder.lat, selectedOrder.longi);
              setOrderAddress(address);
          } else {
              setOrderAddress(`${selectedOrder.customer_location || selectedOrder.customer_address}, ${selectedOrder.customer_city}, ${selectedOrder.customer_state}, ${selectedOrder.customer_pincode}`);
          }
      };
  
      fetchOrderAddress();
  }, [selectedOrder]);
  


    return (
        <>
            <section className='py-4 bg-light'>
                <div className='px-3'>

                    <div className='d-flex'>
                        <p className='sec-heading'>Orders Delivered</p>
                        <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>History</span>
                    </div>

                    <div className='d-flex bg-white rounded-4'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue py-3 px-3"></i>
                        <input
                            type="text"
                            className="form-input rounded-4 border-0"
                            placeholder="Search Order"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>

                    <div className="table-responsive bg-white rounded-4 mt-4">
                        <table className='w-100'>
                            <tr style={{ borderBottom: '2px solid var(--darkblue)' }}>
                                <th className='px-3 py-3'>Order Date</th>
                                <th className='px-3 py-3'>Agent Delivered</th>
                                <th className='px-3 py-3'>Agent Contact</th>
                                <th className='px-3 py-3'>Order Status</th>
                                <th className='px-3 py-3'>Details</th>
                            </tr>


                            {filteredOrders.length > 0 ? (
                                filteredOrders.map((order, index) => (
                                    <tr className='text-muted fw-semibold' style={{ backgroundColor: index % 2 === 0 ? 'var(--peach)' : 'white' }}>
                                        <td className='px-3 py-2'>{formatDate(order.order_date) || 'NA'}</td>
                                        <td className='px-3 py-2'>{order.delivery_agent_name || 'NA'}</td>
                                        <td className='px-3 py-2'>{order.delivery_agent_phone || 'NA'}</td>
                                        <td className='px-3 py-2 text-success'>{order.order_status || 'NA'}</td>
                                        <td className='px-3 py-2 cursor-pointer' onClick={() => handleShowDetail(order)}><span className='danger-btn'>View</span></td>
                                    </tr>
                                ))
                            )

                                : (
                                    <>
                                        <tr className='text-center'>
                                            <td colSpan='5'>
                                                <img src={StaffImg1} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10 my-3' alt='Staff' />
                                                <p className='fw-bold'>No Orders Delivered yet.</p>
                                            </td>
                                        </tr>
                                    </>
                                )}
                        </table>
                    </div>

                </div>
            </section>


            {showDetail && selectedOrder && orderAddress && (
        <>
          <section className='invoice-dialog px-2'>
            <div className='invoice-dialog-inner animate__animated animate__zoomIn col-lg-8 mx-auto px-lg-5 py-lg-5 px-3 py-3 text-start'>

              <p className='sec-heading fs-4'>Order Detail</p>

              <div className='invoice-area my-4'>
                <div className='d-flex justify-content-between'>
                  <p className='para-text'><span className='fw-semibold'>Customer Details:</span><br />Name: {selectedOrder.customer_name}
                  <br />Mobile No: {selectedOrder.customer_mobile}<br /> 
                  Delivery Address: {orderAddress}</p>
                  <p className='para-text'><span className='fw-semibold'>Order Details:</span><br />Order id: {selectedOrder.order_id}<br />Placed On: {formatDate(selectedOrder.order_date)}</p>
                </div>
                {/* flex ends */}
                <hr />

                <div className='table-responsive'>
                  <table className='w-100'>
                    <tr>
                      <th className='px-2 py-2'>Product</th>
                      <th className='px-2 py-2'>Price</th>
                      <th className='px-2 py-2'>Qty</th>
                      <th className='px-2 py-2'>Total ₹</th>
                      <th className='px-2 py-2'>Sold By Branch</th>
                    </tr>

                    {typeof selectedOrder.order_items === 'string' ? (
                      (() => {
                        try {
                          const parsedItems = JSON.parse(selectedOrder.order_items);
                          if (Array.isArray(parsedItems)) {
                            return parsedItems.map((item, index) => (
                              <tr key={index}>
                                <td className='px-2 py-2'>{item.product_name}</td>
                                <td className='px-2 py-2'>{item.product_price}</td>
                                <td className='px-2 py-2'>{item.quantity}</td>
                                <td className='px-2 py-2'>{item.product_price * item.quantity}</td>
                                <td className='px-2 py-2'>{item.subadmin_name}</td>
                              </tr>
                            ));
                          }
                        } catch (error) {
                          return <p>Failed to get items.</p>
                        }
                      })()
                    ) : (
                      <p>No items available.</p>
                    )}

                  </table>
                </div>
                {/* table area */}

                <hr />

                <p className='para-text'>Grand Total {selectedOrder.total_amount}<br />Payment Mode: {selectedOrder.payment_mode} <br />Payment Id: {selectedOrder.payment_id || 'NA'} <br />Payment Status: {selectedOrder.payment_status}</p>
                <p className='para-text'><span className='text-success fw-semibold'>OTP for Verfication: {selectedOrder.otp}</span><br />This Order has been {selectedOrder.order_status} by {selectedOrder.delivery_agent_name}.<br/>You can contact Delivery Agent on {selectedOrder.delivery_agent_phone}</p>

              </div>
              {/* invoice ends */}
              <button className='danger-btn' onClick={() => setShowDetail(false)}>Close</button>


            </div>
          </section>
        </>
      )}

{loading && <Loading setLoading={setLoading} />}


        </>
    )
}

export default DeliveryHistory
